import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-pending-changes-dialog',
	templateUrl: './pending-changes-dialog.component.html',
	standalone: false,
})
export class PendingChangesDialogComponent {
	constructor(public dialogRef: MatDialogRef<PendingChangesDialogComponent>) {}

	close(val: boolean) {
		this.dialogRef.close(val);
	}
}
